/* The 1040px content column from the blueprint, centred, with the token
 * gutter: 16px on a phone, 32px from 720px up. */
.main {
  max-width: calc(var(--column) + 2 * var(--gutter));
  margin: 0 auto;
  padding: 24px var(--gutter) 48px;
}
